export const GROUP_DETAIL_GET_ITEM_SHARED_BY_ME_REQUEST = 'GROUP_DETAIL_GET_ITEM_SHARED_BY_ME_REQUEST';
export const GROUP_DETAIL_GET_ITEM_SHARED_BY_ME_SUCCESS = 'GROUP_DETAIL_GET_ITEM_SHARED_BY_ME_SUCCESS';
export const GROUP_DETAIL_GET_ITEM_SHARED_BY_ME_FAILURE = 'GROUP_DETAIL_GET_ITEM_SHARED_BY_ME_FAILURE';
